<template>
  <v-text-field v-model="value" :label="prop.text" :readonly="readonly" :id="prop.value" 
    :name="prop.text" :error-messages="error">
    <template #append>
      <v-fade-transition leave-absolute>
        <v-icon :color="prop.color">{{value}}</v-icon>
      </v-fade-transition>
    </template>
  </v-text-field>
</template>

<style scoped>

</style>

<script>
  import IconInput from "./iconInput.ts";
  export default IconInput;
</script>